export const OPTIONS_FILTER_VACANCY_REQUEST = [
  { label: 'Todas', value: null },
  { label: 'Pendiente RRHH', value: 0 },
  { label: 'Aprobada', value: 1 },
  { label: 'Rechazada', value: 2 },
  { label: 'A modificar', value: 3 },
  { label: 'Pendiente Subárea', value: 10 },
  { label: 'A modificar subárea', value: 13 },
  { label: 'Pendiente Área', value: 20 },
  { label: 'A modificar área', value: 23 }
];
